import { render, staticRenderFns } from "./bindCate.vue?vue&type=template&id=19dc1c67&scoped=true"
import script from "./bindCate.vue?vue&type=script&lang=js"
export * from "./bindCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc1c67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19dc1c67')) {
      api.createRecord('19dc1c67', component.options)
    } else {
      api.reload('19dc1c67', component.options)
    }
    module.hot.accept("./bindCate.vue?vue&type=template&id=19dc1c67&scoped=true", function () {
      api.rerender('19dc1c67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/sort/jingdongCate/bindCate.vue"
export default component.exports